/// <amd-module name="typeahead/features/RedirectCubaPackageSearch" />
/// <amd-dependency path="typeahead/core/context" name="coreContext"/>
import {FormSubmittedMessage} from "typeahead/core/message/FormSubmittedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {ISuggestionData} from "typeahead/core/Suggestion";
import {SiteParam, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

interface IChildAges {
    childAges: number[];
}

interface IFormData {
    destinationId: string;
    fromDate: string;
    locale: string;
    originTla: string;
    rooms: IChildAges[];
    toDate: string;
    totalAdults: number;
    totalChildren: number;
}

const REDIRECT_SERVICE: string = "https://threepp-comingle." + (coreContext.environment === "prod" ? "prod-p" : "int") +
    ".expedia.com/api/v1/build3ppSrpLink";

export class RedirectCubaPackageSearch {
    private readonly applicableClientIds: string [] = ["Homepage", "AWSHomepage", "PackageLandingPage"];
    private readonly applicablePackageTypes: string [] = ["FH"];

    constructor() {
        TypeaheadMessage.subscribe(FormSubmittedMessage.getTopic(),
            (topic: string, message: FormSubmittedMessage) => {
                if (message.isFormValid() && this.isRedirectApplicable()) {
                    if (message.getEvent()) {
                        let redirectPath: string = this.getRedirectPath($(message.getEvent().currentTarget));
                        if (redirectPath) {
                            message.getEvent().preventDefault();
                            this.submitFormData(this.collectFormData(message.getEvent()), redirectPath);
                        }
                    }
                }
            });
    }

    private isRedirectApplicable(): boolean {
        let clientId: string = TypeaheadUtils.getClientId();
        let shortPackageType: string = TypeaheadUtils.getShortPackageType();
        return (this.applicableClientIds.indexOf(clientId) > -1 &&
            this.applicablePackageTypes.indexOf(shortPackageType) > -1);
    }

    private getRedirectPath($form: JQuery): string {
        let taJsonString: string = $form.find("input[data-gcw-field-type=destination]:visible").
            closest("div.autocomplete").find("input[data-gcw-storeable-name=gcw-destination-ta]").val();
        if (taJsonString) {
            let taJson: ISuggestionData = JSON.parse(taJsonString);
            if (taJson.redirectPath) {
                return window.location.protocol + "//" + window.location.host + taJson.redirectPath;
            }
        }
        return undefined;
    }

    private collectFormData(event: JQueryEventObject): IFormData {
        let formData: IFormData = <IFormData> {};
        formData.locale = TypeaheadUtils.getLocale();
        let originData: string = event.target["package-origin-hp-package-ta"].value;
        formData.originTla = originData ? (<ISuggestionData> JSON.parse(originData)).airportCode : undefined;
        let destData: string = event.target["package-destination-hp-package-ta"].value;
        formData.destinationId = destData ? (<ISuggestionData> JSON.parse(destData)).regionId : undefined;

        formData.fromDate = event.target["package-departing-hp-package"].value;
        formData.toDate = event.target["package-returning-hp-package"].value;

        formData.rooms = [];
        formData.totalAdults = 0;
        formData.totalChildren = 0;
        let roomCount = Number($("form:visible")[0]["package-rooms-hp-package"].value);
        for (let i: number = 1; i <= roomCount; i++) {
            let adultCount: number = Number(event.target["package-" + i + "-adults-hp-package"].value);
            let childCount: number = Number(event.target["package-" + i + "-children-hp-package"].value);
            let childAges: number[] = [];
            for (let j: number = 1; j <= childCount; j++) {
                childAges.push(Number(event.target["package-" + i + "-age-select-" + j + "-hp-package"].value));
            }
            formData.rooms.push({childAges});
            formData.totalAdults += adultCount;
            formData.totalChildren += childCount;
        }
        return formData;
    }

    private submitFormData(data: IFormData, defaultRedirectPath: string): void {
        $.ajax({
            beforeSend: (jqXHR, settings) => {
                this.setRequestHeaders(jqXHR);
            },
            data: JSON.stringify(data),
            dataType: "json",
            error: () => {
                location.href = defaultRedirectPath;
            },
            success: ((response) => {
                if (response.srpUrl) {
                    window.location.href = response.srpUrl;
                } else {
                    location.href = defaultRedirectPath;
                }
            }),
            type: "POST",
            url: REDIRECT_SERVICE,
        });
    }

    private setRequestHeaders(jqXHR: JQueryXHR): void {
        let guid = TypeaheadUtils.getGuid();
        jqXHR.setRequestHeader("Content-Type", "application/json");
        jqXHR.setRequestHeader("Client-Token", "ess-cuba-redirect");
        jqXHR.setRequestHeader("Session-ID", guid);
        jqXHR.setRequestHeader("Transaction-ID", guid);
        jqXHR.setRequestHeader("Message-ID", guid);
        jqXHR.setRequestHeader("Site-Id", coreContext.siteid);
        jqXHR.setRequestHeader("Tpid", String(TypeaheadUtils.getSiteParamValue(SiteParam.tpid)));
        jqXHR.setRequestHeader("Eapid", String(TypeaheadUtils.getSiteParamValue(SiteParam.eapid)));
        jqXHR.setRequestHeader("Duaid", String(TypeaheadUtils.getCookie("DUAID")));
    }
}
